/* Alpacas Foods — Hero carrossel (custom element). Porta Hero.tsx (sem React). */
if (!customElements.get('carousel-hero')) {
  customElements.define('carousel-hero', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.n = this.slides.length;
      this.idx = 0;
      this.paused = false;
      this.rotateMs = parseInt(this.dataset.rotate, 10) || 7000;
      if (this.n <= 1) return;

      var prev = this.querySelector('[data-prev]');
      var next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () { this.go(this.idx - 1); }.bind(this));
      if (next) next.addEventListener('click', function () { this.go(this.idx + 1); }.bind(this));
      this.dots.forEach(function (d, i) {
        d.addEventListener('click', function () { this.go(i); }.bind(this));
      }.bind(this));

      this.addEventListener('mouseenter', function () { this.paused = true; }.bind(this));
      this.addEventListener('mouseleave', function () { this.paused = false; }.bind(this));

      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.render();
      if (!this.reduce) this.schedule();
    }

    disconnectedCallback() { clearTimeout(this.timer); }

    schedule() {
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        if (!this.paused) this.go(this.idx + 1);
        else this.schedule();
      }.bind(this), this.rotateMs);
    }

    go(i) {
      this.idx = ((i % this.n) + this.n) % this.n;
      this.render();
      if (!this.reduce) this.schedule();
    }

    render() {
      this.slides.forEach(function (s, i) {
        var active = i === this.idx;
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) s.removeAttribute('inert'); else s.setAttribute('inert', '');
      }.bind(this));
      this.dots.forEach(function (d, i) {
        var on = i === this.idx;
        d.classList.toggle('is-on', on);
        d.setAttribute('aria-selected', on ? 'true' : 'false');
      }.bind(this));
    }
  });
}
